// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1f-2";
export var blackBorderOnHover = "_1f-7";
export var cell = "_1f-6";
export var cellContainer = "_1f-3";
export var checked = "_1f-8";
export var disabled = "_1f-5";
export var featuredIconCellContainer = "_1f-9";
export var featuredIconTextContainer = "_1f-b";
export var featuredIconWrapper = "_1f-a";
export var noBorder = "_1f-c";
export var orangeSelectedRow = "_4f-3";
export var overflowableText = "_1f-0";
export var overflowableTextContainer = "_1f-1";
export var row = "_1g-0";
export var rowCheckboxCell = "_1f-4";
export var selectableTable = "_4f-2";